import React from 'react';
import { SystemTypeCardData } from '../types';
import { getSuitabilityColor } from '../utils';

export interface SystemTypeCardProps {
  data: SystemTypeCardData;
  className?: string;
}

export const SystemTypeCard: React.FC<SystemTypeCardProps> = ({ data, className = '' }) => {
  const { title, systemType, suitability, reasons, constraints, longevity, replacements } = data;

  const suitabilityColor = getSuitabilityColor(suitability);

  return (
    <div className={`system-type-card ${className}`}>
      <div className="card-header">
        <h3 className="card-title">{title}</h3>
        <span className="system-type-badge">{systemType}</span>
      </div>

      <div className="suitability-section">
        <span
          className="suitability-badge"
          style={{ backgroundColor: suitabilityColor, color: '#fff' }}
        >
          {suitability.toUpperCase()} SUITABILITY
        </span>
      </div>

      {reasons.length > 0 && (
        <div className="reasons-section">
          <h4 className="section-title">Reasons</h4>
          <ul className="reasons-list">
            {reasons.map((reason, index) => (
              <li key={index}>{reason}</li>
            ))}
          </ul>
        </div>
      )}

      {constraints.length > 0 && (
        <div className="constraints-section">
          <h4 className="section-title">Constraints</h4>
          <ul className="constraints-list">
            {constraints.map((constraint, index) => (
              <li key={index}>{constraint}</li>
            ))}
          </ul>
        </div>
      )}

      <div className="longevity-section">
        <div className="longevity-badge">
          <span className="badge-label">Lifespan:</span>
          <span className="badge-value">
            {longevity.min}-{longevity.max} years
          </span>
        </div>
        <div className="replacements-badge">
          <span className="badge-label">Replacements:</span>
          <span className="badge-value">{replacements}</span>
        </div>
      </div>
    </div>
  );
};
